const navigateToOtherHost = (link: string) => window.location.replace(link);

export default navigateToOtherHost;
